if (!customElements.get('adev-featured-flavors')) {
    customElements.define('adev-featured-flavors', class adevFeaturedFlavors extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-featured-flavors="carousel"]');
        }
        
        shopifyCustomizerInit() {
            if (!Shopify.designMode) return;

            document.addEventListener('shopify:block:select', (event) => {
                const blockId = event.detail.blockId;
                const blockEl = this.querySelector(`[data-adev-featured-flavors="carousel-item"][data-block-id="${blockId}"]`);
                
                if (blockEl) {
                    const index = parseInt(blockEl.getAttribute('data-index'), 10);
                    if (this.carouselInstance) {
                        this.carouselInstance.select(index);
                    }
                }

            });
        }
        
        initCarousel(){
            this.carouselInstance = new Flickity(this.carouselEl, {
                cellAlign: 'center',
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: 1,
                groupCells: 1,
                on: {
                    change: (index) => {
                        this.updateDots(index);
                        this.updateSlideButtons(index);
                        if (this.lightbox) this.lightbox.reload();
                    }
                }
            });

            this.initSlideButtons();
            this.initDots();
            this.initArrows();

            const index = this.carouselInstance.selectedIndex;
            
            this.updateDots(index);
            this.updateSlideButtons(index);

            this.shopifyCustomizerInit();

            this.lightbox = GLightbox({
                selector: '.glightbox',
                arrows: false,
                zoomable: true,  touchNavigation: false,   // disables swipe left/right
                keyboardNavigation: false, // disables arrow keys
                draggable: false,         // extra safety
                loop: false,
            });
        }

        initSlideButtons(){
            const slideButtons = this.querySelectorAll('[data-adev-featured-flavors="slide-button"]');

            slideButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();

                    const index = parseInt(button.getAttribute('data-index'), 10);
                    this.carouselInstance.select(index);
                });
            });
        }

        initDots(){
            const dots = this.querySelectorAll('[data-adev-featured-flavors="carousel-dot"]');

            dots.forEach(dot => {
                dot.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    const index = parseInt(dot.getAttribute('data-index'), 10);
                    this.carouselInstance.select(index);
                });
            });

            const selectedDot = this.querySelector(`[data-adev-featured-flavors="carousel-dot"][data-index="0"]`);
            if(selectedDot){
                selectedDot.classList.add('is--active');
            }
        }

        initArrows(){
            const prevButton = this.querySelector('[data-adev-featured-flavors="carousel-prev"]');
            const nextButton = this.querySelector('[data-adev-featured-flavors="carousel-next"]');

            if (!prevButton || !nextButton) return;

            prevButton.addEventListener('click', () => {
                this.carouselInstance.previous();
            });

            nextButton.addEventListener('click', () => {
                this.carouselInstance.next();
            });
        }

        updateDots(index) {
            const carouselItem = this.querySelector(`[data-adev-featured-flavors="carousel-item"][data-carousel-index="${index}"]`);
            if(!carouselItem) return;

            const carouselItemIndex = carouselItem.getAttribute('data-index');

            const dots = this.querySelectorAll('[data-adev-featured-flavors="carousel-dot"]');

            dots.forEach(dot => dot.classList.remove('is--active'));

            const activeDot = this.querySelector(`[data-adev-featured-flavors="carousel-dot"][data-index="${carouselItemIndex}"]`);
            if(activeDot){
                activeDot.classList.add('is--active');
            }
        }

        updateSlideButtons(index) {
            const carouselItem = this.querySelector(`[data-adev-featured-flavors="carousel-item"][data-carousel-index="${index}"]`);
            if(!carouselItem) return;
            
            const carouselItemIndex = carouselItem.getAttribute('data-index');

            const slideButtons = this.querySelectorAll('[data-adev-featured-flavors="slide-button"]');
            slideButtons.forEach(button => button.classList.remove('is--active'));

            const activeButton = this.querySelector(`[data-adev-featured-flavors="slide-button"][data-index="${carouselItemIndex}"]`);
            if(activeButton){
                activeButton.classList.add('is--active');
            }
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
            }
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }

    });
}